var map = {
	"./SkinAlex64x64.png": 1474,
	"./SkinAlexReference64x64.png": 17608,
	"./SkinSteve64x64.png": 71630,
	"./SkinSteveDiamondArmor256x256.png": 1395,
	"./SkinSteveDiamondArmor64x64.png": 46908,
	"./SkinSteveReference64x64.png": 47677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15572;